module.exports = __webpack_public_path__ + "static/media/ipk2022_pkmaker.d7f430fa.png";